import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ReferralButton } from './ReferralButton';
export function StickyMobileCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 620);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-268" data-mp="32p6p4hrg3yu">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-hairline bg-base/90 px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl lg:hidden" data-id="element-269" data-mp="33qr3zko22t8">
          <ReferralButton location="sticky_mobile" size="lg" showArrow className="w-full" data-id="element-270" data-mp="3ggu0k41li82v">
            Crear mi cuenta
          </ReferralButton>
        </motion.div>}
    </AnimatePresence>;
}